export default "/mediafile.7f2d931e-b2d1b4.png";